import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios'; 
import { useNavigate } from 'react-router-dom';

// Styling
import './MartHome.css';

// Components
import MartHero from './MartHero';
import MartFooter from './MartFooter'; 
import MartProductCard from './MartProductCard'; 
import MartAuthModal from './Login/MartAuthModal'; 

const MART_API_BASE = 'https://api.atrmart.in/martapi';

const categoryIconMap = {
  'All Products': (
    <svg viewBox="0 0 24 24" width="36" height="36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="allGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#00f2fe" /><stop offset="100%" stopColor="#4facfe" />
        </linearGradient>
      </defs>
      <circle cx="12" cy="12" r="10" stroke="url(#allGrad)" strokeWidth="2.5"/>
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" stroke="url(#allGrad)" strokeWidth="1.8"/>
      <path d="M2 12h20" stroke="url(#allGrad)" strokeWidth="1.8"/>
    </svg>
  ),
  'Clothes': (
    <svg viewBox="0 0 24 24" width="36" height="36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="clothGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#ff0844" /><stop offset="100%" stopColor="#ffb199" />
        </linearGradient>
      </defs>
      <path d="M6 2a1 1 0 0 0-1 1v3.34a2 2 0 0 1-.34 1.12L2.5 10.7a1.5 1.5 0 0 0 1.2 2.3h1.8v8a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-8h1.8a1.5 1.5 0 0 0 1.2-2.3l-2.16-3.24A2 2 0 0 1 19 6.34V3a1 1 0 0 0-1-1h-3.5a2.5 2.5 0 0 1-5 0H6z" fill="url(#clothGrad)" />
    </svg>
  ),
  'Electronics': (
    <svg viewBox="0 0 24 24" width="36" height="36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="elecGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#00e676" /><stop offset="100%" stopColor="#b9f6ca" />
        </linearGradient>
      </defs>
      <path d="M4 3h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zm0 2v10h16V5H4zm-2 14h20v2H2v-2zm7-2h6v1H9v-1z" fill="url(#elecGrad)" />
    </svg>
  ),
  'Home Goods': (
    <svg viewBox="0 0 24 24" width="36" height="36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="homeGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#f12711" /><stop offset="100%" stopColor="#f5af19" />
        </linearGradient>
      </defs>
      <path d="M19 10v11h-4v-6h-6v6H5V10l7-7 7 7zM12 5.5L7 10h10l-5-4.5z" fill="url(#homeGrad)" />
    </svg>
  ),
  'Groceries': (
    <svg viewBox="0 0 24 24" width="36" height="36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="grocGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#f107a3" /><stop offset="100%" stopColor="#7b2ff7" />
        </linearGradient>
      </defs>
      <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49A1.003 1.003 0 0 0 20 4H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z" fill="url(#grocGrad)" />
    </svg>
  ),
  'Beauty & Health': (
    <svg viewBox="0 0 24 24" width="36" height="36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="beautyGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#ff007f" /><stop offset="100%" stopColor="#7928ca" />
        </linearGradient>
      </defs>
      <path d="M12 2a4 4 0 0 0-4 4v2H7a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2h-1V6a4 4 0 0 0-4-4zm-2 4a2 2 0 1 1 4 0v2h-4V6zm2 7a2 2 0 1 1 0 4 2 2 0 0 1 0-4z" fill="url(#beautyGrad)" />
    </svg>
  ),
  'Offers & Deals': (
    <svg viewBox="0 0 24 24" width="36" height="36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="dealGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#f857a6" /><stop offset="100%" stopColor="#ff5858" />
        </linearGradient>
      </defs>
      <path d="M12.41 2.58A2 2 0 0 0 11 2H4a2 2 0 0 0-2 2v7c0 .53.21 1.04.59 1.41l9.17 9.17a2 2 0 0 0 2.83 0l7-7a2 2 0 0 0 0-2.83l-9.17-9.17zM6 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" fill="url(#dealGrad)" />
    </svg>
  )
};

const MartHome = ({ user: externalUser, onLoginClick, onLoginSuccess, cart = [], addToCart, removeFromCart,  wishlist = [], toggleWishlist }) => {   
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  
  const [activeCategoryId, setActiveCategoryId] = useState('All');
  const [activeCategoryName, setActiveCategoryName] = useState('All');

  const [localUser, setLocalUser] = useState(null);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const currentUser = externalUser || localUser;

const fetchMartData = useCallback(async () => {
  setLoading(true); 
  try {
    const [pRes, cRes] = await Promise.all([
      axios.get(`${MART_API_BASE}/products`),
      axios.get(`${MART_API_BASE}/categories`)
    ]);
    console.log("Products API:", pRes.data);
    console.log("Categories API:", cRes.data);


    // Consistently extract the array regardless of response nesting
    const prodData = pRes.data?.data || pRes.data?.products || (Array.isArray(pRes.data) ? pRes.data : []);
    const catData = cRes.data?.data || cRes.data?.categories || (Array.isArray(cRes.data) ? cRes.data : []);

    setProducts(prodData);

    console.log("Final Products:", prodData);
    setCategories(catData);
  } catch (err) {
    console.error("Connection failure:", err);
  } finally {
    setLoading(false); 
  }
}, []);
  useEffect(() => { 
    fetchMartData(); 

  }, [fetchMartData]);

  // FIXED CASTING LOGIC MATCHING BOTH INT AND STRING STRIP PROPERTIES
  const filtered = products.filter(product => {
    const productName = (
      product.name ||
      product.product_name ||
      ''
    ).toLowerCase();
  
    const matchSearch = productName.includes(
      search.toLowerCase()
    );
  
    if (activeCategoryId === 'All') {
      return matchSearch;
    }
  
    return (
      matchSearch &&
      String(product.category_id) === String(activeCategoryId)
    );
  });
  
  // Show only first 50 products on homepage
  const homeProducts = filtered.slice(0, 50);

  const scrollToProducts = () => {
    const section = document.getElementById('exclusive-items');
    if (section) section.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="mart-dashboard-wrapper">
      <header className="mart-header-main">
        <div className="mart-container-flex">
          <div className="mart-logo-bold" onClick={() => navigate('/mart')}>
            <h1>ATR <span>MART</span></h1>
          </div>

          <nav className="mart-header-nav-links">
            <span 
              onClick={() => { setActiveCategoryId('All'); setActiveCategoryName('All'); }} 
              className={activeCategoryId === 'All' ? 'active-nav' : ''}
            >
              Home
            </span>
            <span onClick={() => navigate('/martcategories')}>Categories</span>
            <span onClick={() => navigate('/martseller')} className="seller-nav-link">Seller</span>
            <span onClick={() => navigate('/martreseller')} className="reseller-nav-link">Reseller</span>
            <span onClick={() => navigate('/martoffers')}>Offers</span>
          </nav>

          <div className="mart-search-container">
            <input 
              type="text" 
              placeholder="Search premium collections..." 
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <button className="m-search-icon-btn">🔍</button>
          </div>

          <div className="mart-nav-actions">
            <div className="m-nav-btn" onClick={() => navigate('/martwishlist')}>
              <span className="m-icon">♡</span>
              <span className="m-label">Wishlist</span>
              {wishlist.length > 0 && <span className="m-count layout-pink">{wishlist.length}</span>}
            </div>

            <div className="m-nav-btn" onClick={() => navigate('/martcart')}>
              <span className="m-icon">🛒</span>
              <span className="m-label">Cart</span>
              {cart.length > 0 && <span className="m-count-orange layout-neon">{cart.length}</span>}
            </div>

            {!currentUser ? (
              <button className="m-login-btn" onClick={() => setShowOtpModal(true)}>Login</button>
            ) : (
              <div className="m-user-profile">
                <span>{currentUser.name?.split(' ')[0] || 'User'}</span>
              </div>
            )}
          </div>
        </div>
      </header>

      <main className="mart-main-body">
        <MartHero onShopNow={scrollToProducts} />

        <section className="mart-categories-section">
          <div className="section-title-wrap">
            <h2>Shop by Category</h2>
            <div className="divider"></div>
          </div>

          <div className="mart-categories-render-grid">
            <div 
              onClick={() => { setActiveCategoryId('All'); setActiveCategoryName('All'); scrollToProducts(); }}
              className={`premium-category-morphic-card ${activeCategoryId === 'All' ? 'is-selected-active' : ''}`}
            >
              <div className="morphic-card-bg-glow"></div>
              <div className="morphic-icon-wrapper">{categoryIconMap['All Products']}</div>
              <span className="morphic-title-text">All Products</span>
            </div>

            {categories.map(cat => {
              // Exact id matching casting to string to avoid comparison flaws
              const catId = cat.id || cat.category_id;
              const isSelected = String(activeCategoryId) === String(catId);
              const nameValue = cat.name || cat.category_name || '';
              
              let optimizedKey = nameValue;
              if (nameValue.toLowerCase().includes('cloth')) optimizedKey = 'Clothes';
              if (nameValue.toLowerCase().includes('elect')) optimizedKey = 'Electronics';
              if (nameValue.toLowerCase().includes('home')) optimizedKey = 'Home Goods';
              if (nameValue.toLowerCase().includes('groc')) optimizedKey = 'Groceries';
              if (nameValue.toLowerCase().includes('beaut')) optimizedKey = 'Beauty & Health';
              if (nameValue.toLowerCase().includes('offer')) optimizedKey = 'Offers & Deals';

              return (
                <div 
                  key={String(catId)}
                  onClick={() => {
                    setActiveCategoryId(catId);
                    setActiveCategoryName(nameValue);
                    scrollToProducts();
                  }}
                  className={`premium-category-morphic-card ${isSelected ? 'is-selected-active' : ''}`}
                >
                  <div className="morphic-card-bg-glow"></div>
                  <div className="morphic-icon-wrapper">{categoryIconMap[optimizedKey] || categoryIconMap['All Products']}</div>
                  <span className="morphic-title-text">{nameValue}</span>
                </div>
              );
            })}
          </div>
        </section>

        <section className="mart-product-section" id="exclusive-items">
        <div className="section-title-wrap mart-title-row">
  <h2>
    {activeCategoryId === 'All'
      ? 'Exclusive Mart Items'
      : `${activeCategoryName} Collection`}
  </h2>

  <button
    className="view-all-btn"
    onClick={() => navigate('/mart-all-products')}
  >
    View All →
  </button>

  <div className="divider"></div>
</div>
         {loading ? (

  <div className="mart-loader">

    <div className="spinner-glow"></div>

    <span>Updating Live Inventory...</span>

  </div>

) : (

  <div className="mart-grid">

    {filtered.length > 0 ? (

      homeProducts.map(item => (

        <MartProductCard 

          key={item.id || item.product_id}

          item={item} 

          navigate={navigate}

          addToCart={addToCart}

          cart={cart}
removeFromCart={removeFromCart}

          user={currentUser}

          onLoginClick={() => setShowOtpModal(true)}

          // Ensure wishlist comparison uses consistent ID types

          isInWishlist={wishlist.some(w => String(w.id || w.product_id) === String(item.id || item.product_id))}

          toggleWishlist={toggleWishlist} 

        />

      ))

    ) : (

      <div className="mart-empty-state">

        <span className="empty-box-emoji">📦</span>

        <p>No products found in this category right now.</p>

      </div>

    )}

  </div>

)}
        </section>
      </main>

      <MartAuthModal isOpen={showOtpModal} onClose={() => setShowOtpModal(false)} onAuthSuccess={(ud) => { setLocalUser(ud); if(onLoginSuccess) onLoginSuccess(ud); setShowOtpModal(false); }} />
      <MartFooter />
    </div>
  );
};

export default MartHome;